// Ana fonksiyonları tanımla (tekrar kullanılabilir)
function initializeSizePopup(container = document) {
  const sizeButton = container.querySelector("#rdm-bb-size-button");
  const sizePopup = container.querySelector("#rdm-bb-size-popup");
  const closePopup = container.querySelector(".rdm-bb-size-popup-close");
  const tipTemplate = container.querySelector('#rdm-bb-template');
  const tipInput = container.querySelector('#rdm-bb-tip');
  const tektutar = container.querySelector('#tektutar');
  const tektoplam = container.querySelector('#tektoplam');
  const ikitutar = container.querySelector('#ikitutar');
  const ikitoplam = container.querySelector('#ikitoplam');
  const uctutar = container.querySelector('#uctutar');
  const uctoplam = container.querySelector('#uctoplam');

  if (!tipTemplate || !tipInput) return;

  const templatetip = tipTemplate.value;
  const tip = tipInput.value;
  const noktaliTip = tip.replace(/\./g, '').replace(",", "");
  const floatTip = parseFloat(noktaliTip);
  const indirimliTip = floatTip;

  if (tektutar) tektutar.innerText = indirimliTip.toLocaleString('tr-TR', { style: 'decimal', maximumFractionDigits: 2 }) + ` TL`;
  if (ikitutar) {
    const ikiTip = indirimliTip / 2;
    ikitutar.innerText = ikiTip.toLocaleString('tr-TR', { style: 'decimal', maximumFractionDigits: 2 }) + ` TL`;
  }
  if (uctutar) {
    const ucTip = indirimliTip / 3;
    uctutar.innerText = ucTip.toLocaleString('tr-TR', { style: 'decimal', maximumFractionDigits: 2 }) + ` TL`;
  }
  if (tektoplam) tektoplam.innerText = indirimliTip.toLocaleString('tr-TR', { style: 'decimal', maximumFractionDigits: 2 }) + ` TL`;
  if (ikitoplam) ikitoplam.innerText = indirimliTip.toLocaleString('tr-TR', { style: 'decimal', maximumFractionDigits: 2 }) + ` TL`;
  if (uctoplam) uctoplam.innerText = indirimliTip.toLocaleString('tr-TR', { style: 'decimal', maximumFractionDigits: 2 }) + ` TL`;

  if (sizeButton && sizePopup) {
    sizeButton.addEventListener("click", function() {
      sizePopup.style.display = "block";
    });
  }

  if (closePopup && sizePopup) {
    closePopup.addEventListener("click", function() {
      sizePopup.style.display = "none";
    });
  }

  window.addEventListener("click", function(event) {
    if (sizePopup && event.target == sizePopup) {
      sizePopup.style.display = "none";
    }
  });
}

function initializeTextInputs(container = document) {
  var textinputs = [
    { id: 'ymq-attrib-12', maxlength: '1' },
    { id: 'ymq-attrib-11', maxlength: '2' },
    { id: 'ymq-attrib-10', maxlength: '3' },
    { id: 'ymq-attrib-9', maxlength: '4' },
    { id: 'ymq-attrib-4', maxlength: '5' },
    { id: 'ymq-attrib-5', maxlength: '6' },
    { id: 'ymq-attrib-6', maxlength: '7' },
    { id: 'ymq-attrib-7', maxlength: '8' }
  ];

  function addToTextbox(symbol) {
    var selectedValue = container.querySelector('#ymq-attrib-3')?.value;
    var inputToUpdate;
    var manmaxlength;

    if (selectedValue === '1 HARF') {
      inputToUpdate = container.querySelector('#ymq-attrib-12');
      manmaxlength = 1;
    } else if (selectedValue === '2 HARF') {
      inputToUpdate = container.querySelector('#ymq-attrib-11');
      manmaxlength = 2;
    } else if (selectedValue === '3 HARF') {
      inputToUpdate = container.querySelector('#ymq-attrib-10');
      manmaxlength = 3;
    } else if (selectedValue === '4 HARF') {
      inputToUpdate = container.querySelector('#ymq-attrib-9');
      manmaxlength = 4;
    } else if (selectedValue === '5 HARF') {
      inputToUpdate = container.querySelector('#ymq-attrib-4');
      manmaxlength = 5;
    } else if (selectedValue === '6 HARF') {
      inputToUpdate = container.querySelector('#ymq-attrib-5');
      manmaxlength = 6;
    } else if (selectedValue === '7 HARF') {
      inputToUpdate = container.querySelector('#ymq-attrib-6');
      manmaxlength = 7;
    } else if (selectedValue === '8 HARF') {
      inputToUpdate = container.querySelector('#ymq-attrib-7');
      manmaxlength = 8;
    }

    if (inputToUpdate) {
      if (inputToUpdate.value.length < manmaxlength) {
        inputToUpdate.value += symbol.toUpperCase();
        updatePreview(inputToUpdate.value, container);
      }
    }

    var allTextInputs = container.querySelectorAll('.isimelementi input[type="text"]');
    allTextInputs.forEach(function(input) {
      if (input !== inputToUpdate) {
        input.value = '';
      }
    });
  }

  function updatePreview(value, container) {
    var previewElement = container.querySelector('.text-onizleme .ymq_custome_text');
    if (!previewElement) return;
    
    var formattedText = value.split('').map(function(char) {
      return `<span>${char}</span>`;
    }).join('');
    
    previewElement.innerHTML = formattedText;
  }

  var allTextInputs = container.querySelectorAll('.isimelementi input[type="text"]');
  
  allTextInputs.forEach(function(input) {
    input.replaceWith(input.cloneNode(true));
    input = container.querySelector(`#${input.id}`);
    
    input.addEventListener('input', function() {
      this.value = this.value.toUpperCase();
      updatePreview(this.value, container);

      allTextInputs.forEach(function(otherInput) {
        if (otherInput !== input) {
          otherInput.value = '';
        }
      });
    });
  });

  var targetDiv = container.querySelector('div[data-name="properties[Zincir Uzunluğu]"]');
  if (targetDiv) {
    var pricesplitSpans = targetDiv.querySelectorAll('.ymq_r_c_box .ymq-price-split');
    pricesplitSpans.forEach(function(span) {
      span.innerHTML = '/' + span.innerHTML;
    });
  }

  textinputs.forEach(function(input) {
    var inputElement = container.querySelector('#' + input.id);
    if (inputElement) {
      inputElement.setAttribute('maxlength', input.maxlength);
    }
  });

  const attrib3 = container.querySelector('#ymq-attrib-3');
  if (attrib3) {
    attrib3.addEventListener('change', function() {
      var previewDiv = container.querySelector('.text-onizleme');
      if (previewDiv) {
        if (this.value === "") {
          previewDiv.style.display = 'none';
        } else {
          previewDiv.style.display = 'block';
        }
      }
    });
  }
}

function initializeGumusProduct(container = document) {
  const letterCount = container.querySelector('.gumus-harf-sayisi #ymq-attrib-2');
  const nameInput = container.querySelector('.gumus-isim .ymq-input-text');
  const namePreview = container.querySelector('.ymq_custome_text');
  const symbolButtons = container.querySelectorAll('.gumus-symbol-btn');
  const submitButton = container.querySelector('.product-buy-buttons--cta');
  const gumusIsimDiv = container.querySelector('.gumus-isim');

  if (!letterCount || !nameInput || !gumusIsimDiv) return;

  const warningMessage = document.createElement('div');
  warningMessage.style.color = 'red';
  warningMessage.style.fontSize = '12px';
  warningMessage.style.display = 'none';
  nameInput.parentNode.insertBefore(warningMessage, nameInput);

  gumusIsimDiv.setAttribute('data-validate', 'required|minchar:1|maxchar:1');
  nameInput.maxLength = 1;

  letterCount.addEventListener('change', () => {
    const selectedOption = letterCount.options[letterCount.selectedIndex];
    const maxLength = parseInt(selectedOption.value.match(/^\d+/)?.[0], 10) || 0;
    
    gumusIsimDiv.setAttribute('data-validate', `required|minchar:${maxLength}|maxchar:${maxLength}`);
    
    nameInput.value = '';
    nameInput.maxLength = maxLength;
    nameInput.minLength = maxLength;
    checkInputValidity();
  });

  nameInput.addEventListener('input', () => {
    nameInput.value = nameInput.value.toUpperCase();
    if (namePreview) namePreview.textContent = nameInput.value;

    const currentLength = nameInput.value.length;
    const minLength = parseInt(nameInput.minLength, 10) || 0;

    if (currentLength < minLength) {
      warningMessage.textContent = `Lütfen en az ${minLength} karakter giriniz.`;
      warningMessage.style.display = 'block';
    } else {
      warningMessage.style.display = 'none';
    }

    checkInputValidity();
  });

  symbolButtons.forEach(button => {
    button.addEventListener('click', () => {
      const symbol = button.textContent;

      if (nameInput.value.length < nameInput.maxLength) {
        nameInput.value += symbol;
        nameInput.dispatchEvent(new Event('input'));
      } else {
        alert(`En fazla ${nameInput.maxLength} karakter girebilirsiniz.`);
      }
    });
  });

  function checkInputValidity() {
    if (!submitButton) return;
    const currentLength = nameInput.value.length;
    const minLength = parseInt(nameInput.minLength, 10) || 0;
    submitButton.disabled = currentLength < minLength;
  }

  const colorOptions = container.querySelectorAll('.ymq-options-box[data-label="Renk"] input[type="radio"]');
  const heartColorLabel = container.querySelector('.ymq-attrib-item-13_1');

  if (colorOptions.length && heartColorLabel) {
    colorOptions.forEach(option => {
      option.addEventListener("change", function () {
        const selectedLabel = container.querySelector(`label[for="${this.id}"]`);
        if (selectedLabel) {
          const newColor = selectedLabel.style.backgroundColor;
          heartColorLabel.style.backgroundColor = newColor;
        }
      });
    });
  }
}

function initializeRomaProduct(container = document) {
  const romaTarihInput = container.querySelector('.roma-tarih input.ymq-input-text');
  const romaTarihPreview = container.querySelector('.roma-onizleme .ymq-option-custome-text');

  if (!romaTarihInput || !romaTarihPreview) return;

  function toRoman(num) {
    const romanMap = [
      [1000, 'M'], [900, 'CM'], [500, 'D'], [400, 'CD'],
      [100, 'C'], [90, 'XC'], [50, 'L'], [40, 'XL'],
      [10, 'X'], [9, 'IX'], [5, 'V'], [4, 'IV'], [1, 'I']
    ];
    let roman = '';
    for (const [value, numeral] of romanMap) {
      while (num >= value) {
        roman += numeral;
        num -= value;
      }
    }
    return roman;
  }

  function updateRomanPreview() {
    const dateValue = romaTarihInput.value;
    if (dateValue) {
      const [day, month, year] = dateValue.split('-').map(Number);

      const romanYear = toRoman(year);
      const romanMonth = toRoman(month);
      const romanDay = toRoman(day);

      romaTarihPreview.innerHTML = `
        <div>${romanDay}</div>
        <div>${romanMonth}</div>
        <div>${romanYear}</div>
      `;
    }
  }

  romaTarihInput.addEventListener('input', updateRomanPreview);
  romaTarihInput.addEventListener('change', updateRomanPreview);

  const observerRoma = new MutationObserver(updateRomanPreview);
  observerRoma.observe(romaTarihInput, {
    attributes: true,
    attributeFilter: ['value']
  });
}

function updateMultipleTextNodes(container, elementIds, newTexts) {
  elementIds.forEach(function(elementId, index) {
    var element = container.querySelector("#" + elementId);

    if (element && index < newTexts.length) {
      var textNode = element.childNodes[0];

      if (textNode && textNode.nodeType === Node.TEXT_NODE) {
        textNode.nodeValue = newTexts[index];
      }
    }
  });
}

function updateIsimElementText(container, newText, newNote) {
  var isimElements = container.querySelectorAll(".isimelementi .ymq_lable");
  var isimElementsHelp = container.querySelectorAll(".isimelementi .ymq_help_box p");
  
  isimElements.forEach(function(element) {
    element.textContent = newText;
  });

  isimElementsHelp.forEach(function(element) {
    element.textContent = newNote;
  });
}

function initializeProductTranslations(container = document) {
  var pageURL = window.location.href;
  
  const productContainers = [
    { id: '7707163623539', selector: '[data-product-id*="7707163623539"]' },
    { id: '7852411912307', selector: '[data-product-id*="7852411912307"]' },
    { id: '6788538597491', selector: '[data-product-id*="6788538597491"]' }
  ];

  productContainers.forEach(prod => {
    const productContainer = container.querySelector(prod.selector);
    if (!productContainer) return;

    const ymqLabelZincir = productContainer.querySelector("#option-box-2 .ymq-option-title .ymq_lable");
    const ymqLabelHarf = productContainer.querySelector("#option-box-3 .ymq-option-title .ymq_lable");
    const ymqLabelHarfSelect = productContainer.querySelector("#option-box-3 #ymq-attrib-3 .ymq-options-default");
    const ymqLabelHarfNote = productContainer.querySelector("#option-box-3 .ymq_help_box p b");
    const ymqBoxPriceAddons = productContainer.querySelector("#ymq-box #ymq-price-addons");

    const ymqLabelHarfSelectElements = [
      "ymq-attrib-3_5", "ymq-attrib-3_6", "ymq-attrib-3_7", "ymq-attrib-3_8",
      "ymq-attrib-3_2", "ymq-attrib-3_3", "ymq-attrib-3_4"
    ];

    if (!ymqLabelZincir) return;

    if (pageURL.includes("/en/products")) {
      ymqLabelZincir.textContent = "Chain Length";
      if (ymqLabelHarf) ymqLabelHarf.textContent = "Number of Letters";
      if (ymqLabelHarfSelect) ymqLabelHarfSelect.textContent = "Please choose";
      if (ymqLabelHarfNote) ymqLabelHarfNote.textContent = "(Cost is 1700 TL per letter/symbol)";
      if (ymqBoxPriceAddons) ymqBoxPriceAddons.innerHTML = 'Additional amount to be added to your cart <span id="ymq-addons-price"></span>';

      updateMultipleTextNodes(productContainer, ymqLabelHarfSelectElements, [
        "1 letter", "2 letter", "3 letter", "4 letter",
        "5 letter", "6 letter", "7 letter", "8 letter"
      ]);

      updateIsimElementText(productContainer, "Enter text", "You can also add the following symbols.");
    } else if (pageURL.includes("/ru/products")) {
      ymqLabelZincir.textContent = "Длина цепочки";
      if (ymqLabelHarf) ymqLabelHarf.textContent = "Количество букв";
      if (ymqLabelHarfSelect) ymqLabelHarfSelect.textContent = "Выберите, пожалуйста";
      if (ymqLabelHarfNote) ymqLabelHarfNote.textContent = "(Стоимость составляет 1700 TL за букву/символ)";
      if (ymqBoxPriceAddons) ymqBoxPriceAddons.innerHTML = 'Дополнительная сумма, которую нужно добавить в корзину <span id="ymq-addons-price"></span>';

      updateMultipleTextNodes(productContainer, ymqLabelHarfSelectElements, [
        "1 буква", "2 буква", "3 буква", "4 буква",
        "5 буква", "6 буква", "7 буква", "8 буква"
      ]);

      updateIsimElementText(productContainer, "Введите текст", "Вы также можете добавить следующие символы.");
    }
  });
}

function initializeAllProducts(container = document) {
  initializeSizePopup(container);
  initializeTextInputs(container);
  initializeGumusProduct(container);
  initializeRomaProduct(container);
  initializeProductTranslations(container);
}

document.addEventListener('DOMContentLoaded', function() {
  initializeAllProducts(document);
});

function checkExistingDialogs() {
  const dialogs = document.querySelectorAll('dialog.product-quick-add[open]');
  
  dialogs.forEach(dialog => {
    const content = dialog.querySelector('ymq-option');
    if (content) {
      initializeAllProducts(dialog);
    }
  });
}

function observeQuickAddButtons() {
  document.body.addEventListener('click', function(e) {
    const quickAddBtn = e.target.closest('[data-quick-add-btn]');
    
    if (quickAddBtn) {
      setTimeout(() => {
        checkAndInitializeDialog();
      }, 300);
    }
  });
}

function checkAndInitializeDialog() {
  const openDialogs = document.querySelectorAll('dialog.product-quick-add[open]');
  
  openDialogs.forEach(dialog => {
    const currentProductId = dialog.getAttribute('data-product-id');
    const lastInitializedProductId = dialog.dataset.rdmLastProductId;
    
    if (dialog.dataset.rdmInitialized === 'true' && currentProductId === lastInitializedProductId) {
      return;
    }
    
    if (currentProductId !== lastInitializedProductId) {
      dialog.dataset.rdmInitialized = 'false';
    }
    
    let attempts = 0;
    const maxAttempts = 20;
    
    const checkInterval = setInterval(() => {
      attempts++;
      
      const ymqOption = dialog.querySelector('ymq-option');
      const productForm = dialog.querySelector('.product-quick-add__inner');
      
      if (ymqOption && productForm) {
        clearInterval(checkInterval);
        
        dialog.dataset.rdmInitialized = 'true';
        dialog.dataset.rdmLastProductId = currentProductId;
        
        setTimeout(() => {
          initializeAllProducts(dialog);
        }, 500);
        
      } else if (attempts >= maxAttempts) {
        clearInterval(checkInterval);
      }
    }, 100);
  });
}

function observeDialogChanges() {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1 && node.matches && node.matches('dialog.product-quick-add')) {
            setTimeout(checkAndInitializeDialog, 300);
          }
          
          if (node.nodeType === 1 && node.closest && node.closest('dialog.product-quick-add[open]')) {
            setTimeout(checkAndInitializeDialog, 300);
          }
        });
      }
      
      if (mutation.type === 'attributes') {
        const target = mutation.target;
        
        if (target.matches('dialog.product-quick-add')) {
          if (mutation.attributeName === 'open' && target.hasAttribute('open')) {
            setTimeout(checkAndInitializeDialog, 300);
          }
          
          if (mutation.attributeName === 'data-product-id') {
            target.dataset.rdmInitialized = 'false';
            setTimeout(checkAndInitializeDialog, 300);
          }
        }
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['open', 'data-product-id', 'data-section-id']
  });
}

function observeDialogClose() {
  document.body.addEventListener('click', function(e) {
    const closeBtn = e.target.closest('[data-quick-add-modal-close]');
    if (closeBtn) {
      const dialog = closeBtn.closest('dialog.product-quick-add');
      if (dialog) {
        // Dialog kapandı
      }
    }
  });
  
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      const openDialog = document.querySelector('dialog.product-quick-add[open]');
      if (openDialog) {
        // Dialog ESC ile kapandı
      }
    }
  });
}

function startAllObservers() {
  observeQuickAddButtons();
  observeDialogChanges();
  observeDialogClose();
  
  setTimeout(checkExistingDialogs, 1000);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', startAllObservers);
} else {
  startAllObservers();
}

document.addEventListener('shopify:section:load', function(event) {
  setTimeout(() => {
    initializeAllProducts(event.target);
    checkExistingDialogs();
  }, 500);
});
